import React, { useEffect, useState } from "react";
import { useStaticQuery, graphql } from "gatsby"
import { Link } from "@StarberryUtils";

import ModalTiny from "react-bootstrap/Modal"

import { Container, Row, Col, Tabs, Tab } from "react-bootstrap"
import img01 from "../../../images/home/Properties/img01.png"
import tab01 from "../../../images/home/Properties/tab-img01.png"
import img02 from "../../../images/home/Properties/img02.png"
import desk01 from "../../../images/home/Properties/desk01.png"
import desk02 from "../../../images/home/Properties/desk02.png"
import desk03 from "../../../images/home/Properties/desk03.png"
import desk04 from "../../../images/home/Properties/desk04.png"
import labelIMG from "../../../images/label.png"
//import ScrollAnimation from "react-animate-on-scroll";
import ImageTransform from "../../common/ggfx-client/module/components/image-transform";
import {capitalizeFirstLetter} from "../../SearchResult/utills";
import Slider from "react-slick";
import _ from "lodash";
import "./PeopleProperties.scss"
import { PhoneIconBlue, EnvelopeIconBlue, WhatsAppIconBlue,EmailIconWhite,CloseIcon } from  "../../Icons/Icons";
import { useLocation } from "@reach/router"
import Form from "../../forms/book-a-viewing-form"
import ImageModule from "../../common/Image_Module";
const PeopleProperties = (props) => {
  const location = useLocation();

  const propQuery = useStaticQuery(graphql`
  query {
    glstrapi {
      properties(where: {publish:true}) {
        id
        ggfx_results {
            id
            src_cftle
            src_url
            transforms
            updatedAt
            createdAt
            _id
        }
        address
        images
        featured_property
        display_address
        display_area
        bathroom
        bedroom
        floor_area
        price
        department
        publish
        slug
        property_url
        search_type
        published_at
        extras
        title
        crm_negotiator_id
        negotiator_id
        negotiator_email
      }
    }
  }
`)

 
const shareurl = typeof window !== 'undefined' ? window.location.href : ''

  const [key, setKey] = React.useState('sale');

  const [propItems, setPropItems] = useState([])
  const [propItemslet, setPropItemslet] = useState([])
  const [negotiator, setNegotiator] = React.useState(null);
  const [modalAskformOpen, setAskformOpen] = React.useState(false);
  const getPOA = (data, price) => {
    var permit = 'AED ' + price.toLocaleString();
    if (!_.isEmpty(data?.POA)) {
      if (data.POA == "Y") {
        permit = "PRICE ON APPLICATION";
      }
    }
    return permit;
  }



  const settings = {
    dots: true,
    lazyLoad: true,
    speed: 800,
    slidesToShow: 4,
    slidesToScroll: 3,
    infinite: false,
    arrows: false,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 1520,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1

        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
        },
      },
    ],
  }
  const openAskformModal = () => {
    setAskformOpen(true);
  }
  const closeAskformModal = () => {
    setAskformOpen(false);
  }
  useEffect(() => {
    if (!_.isEmpty(propQuery.glstrapi?.properties)) {
      var properties = propQuery.glstrapi?.properties;
      var sorted = _.orderBy(properties, ['published_at'], ['desc']);
      var areaFilter = sorted;
      if (!_.isEmpty(props.seqno)) {
        areaFilter = _.filter(areaFilter, (o) => { const email = o.crm_negotiator_id?.email || o.negotiator_email; return email == props.seqno; });
      }
      var salesProperties = _.filter(areaFilter, (o) => { return o.search_type == "sales" && (o.featured_property == "Y" || o.featured_property == "N") }).slice(0, 10);
      var rentProperties = _.filter(areaFilter, (o) => o.search_type == "lettings").slice(0, 10);
      if (_.isEmpty(propItems)) {
        if (_.isEmpty(salesProperties)) {
          setKey('rent')
        }
        setPropItems(salesProperties)
      }
      if (_.isEmpty(propItemslet)) {
        setPropItemslet(rentProperties)
      }
    }
  }, [])

  // let salesProps = _.filter(props.propItems, (o) => { return o.search_type === "sales" });
  // let rentProps = _.filter(props.propItems, (o) => { return o.search_type === "lettings" });
  var url = "/properties/for-sale/in-dubai/";
  if (key === "rent") {
    url = "/properties/for-rent/in-dubai/";
  }
  // console.log('length', rentProps.length, salesProps.length)
  // if(rentProps.length > salesProps.length){
  //   url = "/properties/for-rent/in-dubai/";
  // }
  let fshow = "hide"
  if (propItems.length != 0 || propItemslet.length != 0) {
    fshow = "show"
  }
  var location_link = process.env.GATSBY_SITE_URL+location.pathname;
  var whatsapp_link = `https://wa.me/971586234140?text=Hello!%20I%20want%20to%20know%20more%20about%20${location_link}`
	if(location.search.indexOf("utm_source") > 0){
		whatsapp_link = `https://wa.me/971586234140?text=*G*%20Hello!%20I%20want%20to%20know%20more%20about%20${location_link}`
	}
  const formatNumberWithComma = (number) => {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };
  return ( 
    <>
      {fshow == 'show' &&
        <div animateIn='fadeInUp' animateOnce className="people-based-properties-wrap sec-pdy-120">
          <Container>
            <Row>
              <div className="col-md-8 peoplefeatured-heading">
                <h4>Properties Managed by {props.name}</h4>
              </div>

              <div className="col-md-4">
                {!_.isEmpty(props?.seqno) ?
                  <Link className="btn btn-contact see-more-properties-cta" to={`${url}negotiator-${props.link}`}>See More Properties</Link>
                  :
                  <Link className="btn btn-contact see-more-properties-cta" to={`${url}`}>See More Properties</Link>
                }

              </div>
            </Row>
            <div className="people-featured-properties">
            <Tabs
              id="controlled-tab-example"
              activeKey={key}
              onSelect={(k) => setKey(k)}
            >
              {propItems.length != 0 &&
                <Tab eventKey="sale" title={`Properties for Sale`}>
                  <Slider  {...settings}>
                    {propItems.map((item, index) => {
                      // property details url structure
                      let uriStr = "";

                      if (item.search_type === "sales") {
                        uriStr = `properties-for-sale/`
                      } else if (item.search_type === "lettings") {
                        uriStr = `properties-for-rent/`
                      }

                      if (item.department == "commercial") {
                        if (item.search_type === "sales") {
                          uriStr = `commercial-properties-for-sale/`
                        } else if (item.search_type === "lettings") {
                          uriStr = `commercial-properties-for-rent/`
                        }
                      } 
                      // property details url structure

                      let processedImages = JSON.stringify({});
                      if (item?.imagetransforms?.images_Transforms) {
                        processedImages = item.imagetransforms.images_Transforms;
                      }

                      return (

                        <div className="all-products img-zoom">
                          <Link to={'/' + uriStr + item.slug.replace(/_/g, '-') + '-' + item.id}>
                            <div className="properties-wrapper gg ">
                              {item.images && item.images.length > 0 ?
                                <ImageModule 
                                    ImageSrc={item?.images[0] } 
                                    attr={{ alt: item.address?.area +'- Dacha', class: '' }} 
                                    ggfx_results={item?.ggfx_results} 
                                    imagename="property.images.similar_properties"
                                    strapi_id={item?.id} 
                                />     
                                :
                                <img loading="lazy" src={img01} alt={`${item.title} - Dacha`} />
                              }
                            </div>
                          </Link>
                          <div className="about-properties">
                                     <div className="properties-info">
                                        <h2 className="text-md-bold-20-16">
                                          <Link to={'/' + uriStr + item.slug + '-' + item.id}>
                                            {capitalizeFirstLetter(item.title)}
                                          </Link>
                                        </h2>                                    
                                        <div className="price text-md-bold-20-16">
                                          {getPOA(item.extras, item.price)}
                                        </div>
                                        <div className="about-location">
                                          <span><i className="icon-location"></i></span>
                                          <span className="location-info text-xxs">
                                            {/* {item?.address.Address && (item?.address.Address + ", ")}{item?.address.town && (item?.address.town)} */}
                                            {item?.address.Address && (item?.address.Address + ", ")}{item?.address.area && (item?.address.area + ", ")} {item?.address.town && (item?.address.town)}
                                          </span>
                                        </div>                                        
                                          {item.bedroom !== 0 || item.bathroom !== 0 ?
                                            <div className="properties-icons">
                                              {item.bedroom !== 0 &&
                                                <div className="text">
                                                  <span><i className="icon-bedroom"></i></span>
                                                  <span class="text-xxs-bold">
                                                    {item.bedroom}
                                                  </span>
                                                </div>
                                              }
                                              {item.bathroom !== 0 &&
                                                <div className="text">
                                                  <span><i className="icon-bath">
                                                  </i></span>
                                                  <span class="text-xxs-bold">
                                                    {item.bathroom}
                                                  </span>
                                                </div>
                                              }
                                              {item.floor_area !== 0 &&
                                                <div className="text">
                                                  <span><i className="icon-space">
                                                  </i></span>
                                                  <span class="text-xxs-bold">
                                                 { formatNumberWithComma(item.floor_area)} sq.ft
                                                  </span>
                                                </div>
                                              }
                                            </div> : <div className="properties-icons">&nbsp;</div>
                                          }
                                      </div>
                                     
                                          <div className="agent-contact-info">
                                                <Link href={`tel:${negotiator?.Phone ? negotiator?.Phone : "+971 4 423 2006"}`} className="agent-number text-xxs btn btn-light-blue"><span><PhoneIconBlue className="icon-contact-info"/> </span><span>Call</span></Link>
                                                <a href="javascript:void(0)" onClick={openAskformModal} className="text-xxs btn btn-light-blue"><span><EnvelopeIconBlue className="icon-contact-info"/></span><span>Email</span></a>
                                                <Link href={whatsapp_link} className="text-xxs btn btn-light-blue" target="_blank"><span><WhatsAppIconBlue className="icon-contact-info" /></span><span className="d-none"> WhatsApp</span></Link>
                                          </div>
                                             
                                  </div>       

                        </div>
                      )
                    })
                    }

                  </Slider>
                </Tab>
              }
              {propItemslet.length != 0 &&
                <Tab eventKey="rent" title={`Properties for Rent`}>
                  <Slider  {...settings}>
                    {propItemslet.map((item, index) => {
                      // property details url structure
                      let uriStr = "";

                      if (item.search_type === "sales") {
                        uriStr = `properties-for-sale/`
                      } else if (item.search_type === "lettings") {
                        uriStr = `properties-for-rent/`
                      }

                      if (item.department == "commercial") {
                        if (item.search_type === "sales") {
                          uriStr = `commercial-properties-for-sale/`
                        } else if (item.search_type === "lettings") {
                          uriStr = `commercial-properties-for-rent/`
                        }
                      } 
                      // property details url structure

                      let processedImages = JSON.stringify({});
                      if (item?.imagetransforms?.images_Transforms) {
                        processedImages = item.imagetransforms.images_Transforms;
                      }

                      return (

                        <div className="all-products img-zoom">
                          <Link to={'/' + uriStr + item.slug.replace(/_/g, '-') + '-' + item.id}>
                            <div className="properties-wrapper ">
                              {item.images && item.images.length > 0 ?
                                //<img loading="lazy" src={item.images[0]?.url} alt={`${item.title} - Dacha`} />
                                <ImageModule 
                                    ImageSrc={item?.images[0] } 
                                    attr={{ alt: item.address?.area +'- Dacha', class: '' }} 
                                    ggfx_results={item?.ggfx_results} 
                                    imagename="property.images.similar_properties"
                                    strapi_id={item?.id} 
                                />   
                                :
                                <img loading="lazy" src={img01} alt={`${item.title} - Dacha`} />
                              }
                            </div>
                          </Link>
                          <div className="about-properties">
                                     <div className="properties-info">
                                        <h2 className="text-md-bold-20-16">
                                          <Link to={'/' + uriStr + item.slug + '-' + item.id}>
                                            {item.title}
                                          </Link>
                                        </h2>                                    
                                        <div className="price text-md-bold-20-16">
                                          {getPOA(item.extras, item.price)} 
                                        </div>
                                        <div className="about-location">
                                          <span><i className="icon-location"></i></span>
                                          <span className="location-info text-xxs">
                                            {item?.address.Address && (item?.address.Address + ", ")}{item?.address.town && (item?.address.town)}
                                          </span>
                                        </div>                                        
                                          {item.bedroom !== 0 || item.bathroom !== 0 ?
                                            <div className="properties-icons">
                                              {item.bedroom !== 0 &&
                                                <div className="text">
                                                  <span><i className="icon-bedroom"></i></span>
                                                  <span class="text-xxs-bold">
                                                    {item.bedroom}
                                                  </span>
                                                </div>
                                              }
                                              {item.bathroom !== 0 &&
                                                <div className="text">
                                                  <span><i className="icon-bath">
                                                  </i></span>
                                                  <span class="text-xxs-bold">
                                                    {item.bathroom}
                                                  </span>
                                                </div>
                                              }
                                              {item.floor_area !== 0 &&
                                                <div className="text">
                                                  <span><i className="icon-space">
                                                  </i></span>
                                                  <span class="text-xxs-bold">
                                                 { formatNumberWithComma(item.floor_area)} sq.ft
                                                  </span>
                                                </div>
                                              }
                                            </div> : <div className="properties-icons">&nbsp;</div>
                                          }
                                      </div>
                                     
                                          <div className="agent-contact-info">
                                                <Link href={`tel:${negotiator?.Phone ? negotiator?.Phone : "+971 4 423 2006"}`} className="agent-number text-xxs btn btn-light-blue"><span><PhoneIconBlue className="icon-contact-info"/> </span><span>Call</span></Link>
                                                <Link href="javascript:void(0)" onClick={openAskformModal} className="text-xxs btn btn-primary">
                                                        <span><EmailIconWhite className="icon-contact-info" /></span><span>Email</span>
                                                          </Link>                                                
                                                <Link href={whatsapp_link} className="text-xxs btn btn-light-blue" target="_blank"><span><WhatsAppIconBlue className="icon-contact-info" /></span><span className="d-none"> WhatsApp</span></Link>
                                          </div>
                                             
                                  </div>   

                        </div>
                      )
                    })
                    }

                  </Slider>
                </Tab>
              }
            </Tabs>
            </div>
          </Container>
        </div>
      }
        {props?.fullName &&
      <ModalTiny show={modalAskformOpen} onHide={closeAskformModal} className="modal-form-wrapper people-details-form-modal">
        <ModalTiny.Header>
        <div class="modal-close-btn" onClick={closeAskformModal}><CloseIcon /></div>
          <ModalTiny.Title><h4>Contact {props?.fullName}</h4></ModalTiny.Title>
        </ModalTiny.Header>
        <ModalTiny.Body className="event-section people-details-form-modal">
          <Form peopleName={props?.fullName} contactusUrl = {shareurl} form_subject_contact = {"contact person"}/>
        </ModalTiny.Body>
      </ModalTiny>
    }

    </>

  )
}

export default PeopleProperties